module.exports = __webpack_public_path__ + "media/images/jlp-native-app-promo-d0ed8e51e8403408209df7dc6345b237.png";